import { VendorSelect } from "@/components/form/vendor-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is a vendor account id** (`string | null`). */
export type VendorFieldProps = PickerFieldProps<string | null>;

export const VendorField = makePickerField<string | null>({
  name: "VendorField",
  control: VendorSelect,
  popout: true,
});
